import { useLocation, useNavigate } from "react-router-dom";

import { campaignPaths } from "routes/campaign/paths";

/**
 * Opens the Campaign form pages. The current location travels as `from`, so
 * Cancel returns to where the user started.
 */
export const useCampaignNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = { from: `${location.pathname}${location.search}` };

  return {
    openCreate: () => navigate(campaignPaths.create(), { state }),
    openEdit: id => navigate(campaignPaths.edit(id), { state }),
  };
};
